/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { func } from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';

const RebateTooltipTitle = ({ handleClear }) => {
  return (
    <div
      className="sui-text-base sui-font-bold sui-mb-8"
    >
      Filters
      <Button
        variant="text"
        className="sui-underline-none sui-font-regular sui-ml-4 sui-mb-1 sui-text-sm sui-text-[#3e7697]"
        onClick={handleClear}
      >
        Clear All
      </Button>
    </div>
  );
};

RebateTooltipTitle.propTypes = {
  handleClear: func.isRequired
};

export default RebateTooltipTitle;
